import React, { useRef, useState, useEffect } from "react";
import { Field, FormikProvider, useFormik } from "formik";
// import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import { post } from "../../../helpers/api_helper";
import { POST_GetInwardDispatchBarChartData } from "../../../helpers/url_helper";
import { Spin } from "antd";
import * as echarts from "echarts";

const InwardDispatch = () => {
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const formik = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MonthType: 1,
      BarChartDate: [],
      NoOfInward: [],
      NoOfDispatch: [],
      LisOfInwardDispatch: [],
      PeriodType: 1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      MonthType,
      BarChartDate,
      NoOfInward,
      NoOfDispatch,
      LisOfInwardDispatch,
      PeriodType,
    },
  } = formik;

  useEffect(() => {
    getInwardDispatchDetails(1);
  }, []);

  const getInwardDispatchDetails = async (typeid) => {
    formik.setFieldValue("PeriodType", typeid);
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PeriodType: typeid,
    };

    await post(POST_GetInwardDispatchBarChartData, payload)
      .then((response) => {
        formik.setFieldValue("LisOfInwardDispatch", response?.List);
        bindChartData(response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const bindChartData = (list) => {
    let barChartDateArray = [],
      noOfInwardArray = [],
      noOfDispatchArray = [];

    Promise.all(
      list?.map((x) => {
        barChartDateArray.push(x?.BarChartDate);
        noOfInwardArray.push(x?.NoOfInward);
        noOfDispatchArray.push(x?.NoOfDispatch);
      })
    );

    formik.setFieldValue("BarChartDate", barChartDateArray);
    formik.setFieldValue("NoOfInward", noOfInwardArray);
    formik.setFieldValue("NoOfDispatch", noOfDispatchArray);
  };

  const chartRef = useRef();

  useEffect(() => {
    const myChart = echarts.init(chartRef.current);

    const option = {
      title: {
        text: "",
        subtext: "",
      },
      // tooltip: {
      //   trigger: "axis",
      // },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
      },
      // legend: {
      //   data: ["Inward", "Dispatch"],
      // },
      toolbox: {
        show: true,
        feature: {
          dataView: { show: false, readOnly: false },
          magicType: { show: false, type: ["line", "bar"] },
          restore: { show: false },
          saveAsImage: { show: false },
        },
      },
      // calculable: true,
      xAxis: [
        {
          type: "category",
          data: BarChartDate,
        },
      ],
      yAxis: [
        {
          type: "value",
        },
      ],
      series: [
        {
          name: "Inward",
          type: "bar",
          data: NoOfInward,
          // markPoint: {
          //   data: [
          //     { type: "max", name: "Max" },
          //     { type: "min", name: "Min" },
          //   ],
          // },
          // markLine: {
          //   data: [{ type: "average", name: "Avg" }],
          // },
        },
        {
          name: "Dispatch",
          type: "bar",
          data: NoOfDispatch,

          // markLine: {
          //   data: [{ type: "average", name: "Avg" }],
          // },
        },
      ],
      grid: {
        left: 40,
        top: 45,
        right: "8%",
        bottom: "8%",
      },
    };

    myChart.setOption(option);

    // Clean up the chart instance
    return () => {
      myChart.dispose();
    };
  }, [LisOfInwardDispatch]);

  return (
    <>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        {/* <div className="card overflow-hidden mb-0"> */}
        <div className="card mb-2" style={{ height: "calc(100% - 10px)" }}>
          {/* <Tab.Container> */}

          <div className="card-header p-2 border-0 pb-0 flex-wrap">
            <h4 className="heading mb-0 ps-2">Inward/Dispatch</h4>
            <FormikProvider value={formik}>
              <form onSubmit={formik.handleSubmit}>
                <div className="d-flex align-items-center">
                  <Link
                    title="Current Month"
                    className={`btn ${
                      PeriodType == 1 ? "btn-primary" : "btn-outline-primary"
                    } btn-sm`}
                    onClick={(e) => {
                      getInwardDispatchDetails(1);
                    }}
                  >
                    CM
                  </Link>
                  &nbsp;
                  <Link
                    title="Previous Month"
                    className={`btn ${
                      PeriodType == 2 ? "btn-primary" : "btn-outline-primary"
                    } btn-sm`}
                    onClick={(e) => {
                      getInwardDispatchDetails(2);
                    }}
                  >
                    PM
                  </Link>
                </div>
              </form>
            </FormikProvider>
          </div>
          <div>
            <div
              ref={chartRef}
              style={{ width: "100%", height: "407px" }}
            ></div>
          </div>
          {/* 
          <div className="card-body  p-0">
            <div id="overiewChart">
              <ReactApexChart
                options={options}
                series={series}
                type="bar"
                height={300}
              />
            </div>
          </div> */}
          {/* </Tab.Container> */}
        </div>
      </Spin>
    </>
  );
};

export default InwardDispatch;
